export const translationMaxSize = 255;

export const SITE_SEO_GRID_NAME = 'SiteSeoGrid';
export const SITE_CUSTOM_TAGS_GRID_NAME = 'SiteCustomTagsGrid';

export const TRANSLATION_STATUS__APPROVED = 'APPROVED';
export const TRANSLATION_STATUS__PENDING = 'PENDING';
export const TRANSLATION_STATUS__CANCELED = 'CANCELED';

export const translationStatuses = [
  TRANSLATION_STATUS__APPROVED,
  TRANSLATION_STATUS__PENDING,
  TRANSLATION_STATUS__CANCELED,
];

export const TRANSLATION_KEY__DESCRIPTION = 'description';
export const TRANSLATION_KEY__KEYWORDS = 'keywords';
export const TRANSLATION_KEY__TITLE = 'title';

export const CUSTOM_TAG_STATUS__APPROVED = 'APPROVED';
export const CUSTOM_TAG_STATUS__CANCELED = 'CANCELED';
export const CUSTOM_TAG_STATUS__DELETED = 'DELETED';
export const CUSTOM_TAG_STATUS__PENDING = 'PENDING';

export const customTagStatuses = [
  CUSTOM_TAG_STATUS__APPROVED,
  CUSTOM_TAG_STATUS__CANCELED,
  CUSTOM_TAG_STATUS__DELETED,
  CUSTOM_TAG_STATUS__PENDING,
];

export const customTagStatusLangKeys = {
  [CUSTOM_TAG_STATUS__APPROVED]: 'msg.approved',
  [CUSTOM_TAG_STATUS__CANCELED]: 'msg.canceled',
  [CUSTOM_TAG_STATUS__DELETED]: 'msg.deleted',
  [CUSTOM_TAG_STATUS__PENDING]: 'msg.pending',
};

const PAGE__MAIN = 'main-page';
const PAGE__MAIN_WITH_FILTER = 'main-page-with-filter';
const PAGE__USER_REGISTRATION = 'user-registration';
const PAGE__SEARCH = 'search-page';
const PAGE__MODEL_REGISTRATION = 'model-registration';
const PAGE__MODEL_REGISTRATION_BOOTSTRAP = 'model-registration-bootstrap';
const PAGE__AIM_LANDING = 'aim-landing-page';
const PAGE__MOBILE_LANDING = 'mobile-landing-page';
const PAGE__EMAIL_LANDING = 'email-landing-page';
const PAGE__LIVESHOW_LANDING = 'liveshow-list-landing-page';
const PAGE__VIDEO_LANDING = 'video-landing-page';
const PAGE__VIDEO_LANDING_WITH_CATEGORY = 'video-landing-page-with-category';
const PAGE__PHOTO_LANDING = 'photo-landing-page';
const PAGE__PHOTO_LANDING_WITH_CATEGORY = 'photo-landing-page-with-category';
const PAGE__EROTIC_STORY_LANDING = 'erotic-storie-landing-page';
const PAGE__EROTIC_STORY_LANDING_WITH_CATEGORY = 'erotic-storie-landing-page-with-category';
const PAGE__LINGERIE_LANDING = 'lingerie-landing-page';
const PAGE__INTERVIEW_LANDING = 'interview-landing-page';
const PAGE__AWARD_LANDING = 'award-landing-page';
const PAGE__MODEL_PROFILE = 'model-profile';

export const sections = [
  PAGE__MAIN,
  PAGE__MAIN_WITH_FILTER,
  PAGE__USER_REGISTRATION,
  PAGE__SEARCH,
  PAGE__MODEL_REGISTRATION,
  PAGE__MODEL_REGISTRATION_BOOTSTRAP,
  PAGE__AIM_LANDING,
  PAGE__MOBILE_LANDING,
  PAGE__EMAIL_LANDING,
  PAGE__LIVESHOW_LANDING,
  PAGE__VIDEO_LANDING,
  PAGE__VIDEO_LANDING_WITH_CATEGORY,
  PAGE__PHOTO_LANDING,
  PAGE__PHOTO_LANDING_WITH_CATEGORY,
  PAGE__EROTIC_STORY_LANDING,
  PAGE__EROTIC_STORY_LANDING_WITH_CATEGORY,
  PAGE__LINGERIE_LANDING,
  PAGE__INTERVIEW_LANDING,
  PAGE__AWARD_LANDING,
  PAGE__MODEL_PROFILE,
];

export const sectionLangKeys = {
  [PAGE__MAIN]: 'header.main-page',
  [PAGE__MAIN_WITH_FILTER]: 'header.main-page-with-filter',
  [PAGE__USER_REGISTRATION]: 'header.user-registration-page',
  [PAGE__SEARCH]: 'header.search-page',
  [PAGE__MODEL_REGISTRATION]: 'header.model-registration-page',
  [PAGE__MODEL_REGISTRATION_BOOTSTRAP]: 'header.model-registration-page',
  [PAGE__AIM_LANDING]: 'header.aim-landing-page',
  [PAGE__MOBILE_LANDING]: 'header.mobile-landing-page',
  [PAGE__EMAIL_LANDING]: 'header.email-landing-page',
  [PAGE__LIVESHOW_LANDING]: 'header.liveshow-landing-page',
  [PAGE__VIDEO_LANDING]: 'header.video-landing-page',
  [PAGE__VIDEO_LANDING_WITH_CATEGORY]: 'header.video-landing-page-with-category',
  [PAGE__PHOTO_LANDING]: 'header.photo-landing-page',
  [PAGE__PHOTO_LANDING_WITH_CATEGORY]: 'header.photo-landing-page-with-category',
  [PAGE__EROTIC_STORY_LANDING]: 'header.erotic-story-landing-page',
  [PAGE__EROTIC_STORY_LANDING_WITH_CATEGORY]: 'header.erotic-story-landing-page-with-category',
  [PAGE__LINGERIE_LANDING]: 'header.lingerie-landing-page',
  [PAGE__INTERVIEW_LANDING]: 'header.interview-landing-page',
  [PAGE__AWARD_LANDING]: 'header.award-landing-page',
  [PAGE__MODEL_PROFILE]: 'header.model-profile-page',
};

export const translationKeyLangKeys = {
  [TRANSLATION_KEY__DESCRIPTION]: 'header.description',
  [TRANSLATION_KEY__KEYWORDS]: 'header.keywords',
  [TRANSLATION_KEY__TITLE]: 'header.title',
};

export const translationStatusLangKeys = {
  [TRANSLATION_STATUS__APPROVED]: 'msg.approved',
  [TRANSLATION_STATUS__PENDING]: 'msg.pending',
  [TRANSLATION_STATUS__CANCELED]: 'msg.canceled',
};
